import { defineRouting } from 'next-intl/routing';

export const i18nRouting = defineRouting({
  locales: ['en', 'es'],
  defaultLocale: 'es',
  // The landing declares hreflang in <head> (x-default on /es); the Link header next-intl
  // adds would send a second, different x-default.
  alternateLinks: false,
});
